module.exports = __webpack_public_path__ + "media/img/email-green-8c7bf4b3.png";